// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"e6c3c58e","84":"5ce36957","247":"3ffa6ea3","440":"ac49c46e","453":"9d2ab285","627":"902b8a27","738":"d15c7e95","834":"231ea221","842":"445821ef","923":"87bb6ab8","938":"b384654d","963":"095ea8ff"}[chunkId] + ".chunk.js";
};